import React, { useState } from "react";
import api from "../../api";

// Lucide Icons
import {
  Mail,
  Send,
  DollarSign,
  AlertCircle,
  Loader2,
  CreditCard,
  ArrowRight,
  CheckCircle,
  Receipt,
} from "lucide-react";
import "./SendPaidMail.css";
import { useAlert } from "react-alert";

function SendPaidMail({ match }) {
  const alert = useAlert();

  const [email, setEmail] = useState("");
  const [loader, setLoader] = useState(false);
  const [isSent, setIsSent] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async () => {
    try {
      if (!email) {
        setError("Please enter an email address");
        return;
      }

      setError("");
      setLoader(true);

      const payload = { email };
      const userData = await api.sendPaidMail(payload);

      if (userData.success) {
        setIsSent(true);
        setEmail("");
        alert.success(userData.message);
      } else {
        setError("Something went wrong, email not sent");
      }
    } catch (error) {
      console.log(error);
      setError("Something went wrong, email not sent");
    } finally {
      setLoader(false);
    }
  };

  const handleReset = () => {
    setIsSent(false);
    setEmail("");
    setError("");
  };

  return (
    <>
      <div className="admin-forget-pass-container">
        <div className="admin-forget-pass-content">
          {/* Header Section */}
          <div className="admin-forget-pass-header">
            <div className="admin-forget-pass-header-icon">
              <Receipt size={40} />
            </div>
            <h1 className="admin-forget-pass-title">Send Welcome Email</h1>
            <p className="admin-forget-pass-subtitle">
              Send Welcome Email emails to users
            </p>
          </div>

          {/* Main Content */}
          <div className="admin-forget-pass-card">
            {isSent ? (
              /* Success State */
              <div className="admin-forget-pass-success">
                <div className="admin-forget-pass-success-icon">
                  <CheckCircle size={48} />
                </div>
                <h2 className="admin-forget-pass-success-title">
                  Payment Email Sent
                </h2>
                <p className="admin-forget-pass-success-message">
                  Payment confirmation email has been successfully sent to the
                  user. They will receive payment details and confirmation in
                  their inbox.
                </p>
                <div className="admin-forget-pass-success-actions">
                  <button
                    className="admin-forget-pass-success-button"
                    onClick={handleReset}
                  >
                    <ArrowRight
                      size={18}
                      style={{ transform: "rotate(180deg)" }}
                    />
                    Send Another Email
                  </button>
                </div>
              </div>
            ) : (
              /* Form Section */
              <div className="admin-forget-pass-form">
                <div className="admin-forget-pass-input-section">
                  <div className="admin-forget-pass-input-header">
                    <Mail className="admin-forget-pass-input-header-icon" />
                    <label className="admin-forget-pass-input-label">
                      Recipient Email Address
                    </label>
                  </div>

                  <div className="admin-forget-pass-input-wrapper">
                    <Mail className="admin-forget-pass-input-icon" size={20} />
                    <input
                      type="email"
                      className="admin-forget-pass-input"
                      value={email}
                      onChange={(e) => {
                        setEmail(e.target.value);
                        setError("");
                      }}
                      placeholder="Enter recipient's email address..."
                      onKeyPress={(e) => e.key === "Enter" && handleSubmit()}
                    />
                  </div>

                  {error && (
                    <div className="admin-forget-pass-error">
                      <AlertCircle size={16} />
                      <span>{error}</span>
                    </div>
                  )}

                  <div className="admin-forget-pass-input-hint">
                    <DollarSign size={14} />
                    <span>
                      A payment confirmation email will be sent immediately
                    </span>
                  </div>
                </div>

                <button
                  onClick={handleSubmit}
                  className="admin-forget-pass-submit-button"
                  disabled={loader}
                >
                  {loader ? (
                    <>
                      <Loader2 className="admin-forget-pass-loader" size={20} />
                      Sending Payment Email...
                    </>
                  ) : (
                    <>
                      <Send size={20} />
                      Send Payment Confirmation
                    </>
                  )}
                </button>

                {/* <div className="send-paid-mail-info-note">
                  <CreditCard size={16} />
                  <div>
                    <strong>Email Includes:</strong> Payment confirmation,
                    transaction details, and receipt information.
                  </div>
                </div> */}
              </div>
            )}

            {/* Stats/Info Section */}
            {/* <div className="send-paid-mail-info">
              <div className="send-paid-mail-info-item">
                <div className="send-paid-mail-info-icon">
                  <DollarSign size={18} />
                </div>
                <div className="send-paid-mail-info-content">
                  <span className="send-paid-mail-info-label">
                    Payment Confirmation
                  </span>
                  <span className="send-paid-mail-info-value">
                    Transaction Details
                  </span>
                </div>
              </div>
              <div className="send-paid-mail-info-item">
                <div className="send-paid-mail-info-icon">
                  <Receipt size={18} />
                </div>
                <div className="send-paid-mail-info-content">
                  <span className="send-paid-mail-info-label">
                    Digital Receipt
                  </span>
                  <span className="send-paid-mail-info-value">
                    PDF Attachment
                  </span>
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </>
  );
}

export default SendPaidMail;
